import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handoverShipment } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useHandoverShipment = () => {

  const queryClient = useQueryClient();

  return useMutation({

    mutationFn: ( shipmentCode ) =>
      handoverShipment(shipmentCode),

    onSuccess: (_, shipmentCode) => {

      queryClient.invalidateQueries(shipmentKeys.all);

      queryClient.invalidateQueries(
        shipmentKeys.detail(shipmentCode)
      );

    },

  });

};
